export default __webpack_public_path__ + "images/a48d82da246810090e99594052a6c3d7.png";